import { ButtonHTMLAttributes } from "react";
import Spinner from "../Spinner/Spinner";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isPending?: boolean;
}

const TextButton = ({ isPending, children, className = "", ...props }: ButtonProps) => (
  <button
    className={`rounded-lg border-none bg-transparent p-2 text-small font-semibold uppercase text-primary outline-none transition hover:bg-grey hover:text-text ${className}`.trim()}
    style={{
      cursor: isPending ? "not-allowed" : "pointer",
      opacity: isPending ? 0.4 : 1,
      pointerEvents: isPending ? "none" : "inherit",
      userSelect: isPending ? "none" : "inherit",
    }}
    {...props}
  >
    {isPending ? <Spinner color="white" size="0.2rem" /> : children}
  </button>
);

export default TextButton;
